import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { observeElementInViewport } from 'observe-element-in-viewport';
import { useCallback, useEffect, useRef, useState } from 'react';
export default function useIsInViewport() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      isInViewport = _useState2[0],
      setIsInViewport = _useState2[1];

  var target = options.target,
      viewport = options.viewport,
      restOpts = _objectWithoutProperties(options, ["target", "viewport"]);

  var parentRef = useRef(null);
  var childRef = useRef(null);
  var parentCbRef = useCallback(function (node) {
    parentRef.current = node;

    if (viewport) {
      if (isCallbackRef(viewport)) {
        viewport(node);
      } else if (isRefObject(viewport)) {
        viewport.current = node;
      }
    }
  }, [parentRef, viewport]);
  var childCbRef = useCallback(function (node) {
    childRef.current = node;

    if (target) {
      if (isCallbackRef(target)) {
        target(node);
      } else if (isRefObject(target)) {
        target.current = node;
      }
    }
  }, [childRef, target]);
  useEffect(function () {
    return observeElementInViewport(childRef.current, function () {
      return setIsInViewport(true);
    }, function () {
      return setIsInViewport(false);
    }, _objectSpread({}, restOpts, {
      viewport: parentRef.current
    }));
  }, [childRef, restOpts, parentRef]);
  return [isInViewport, childCbRef, parentCbRef];
}

function isRefObject(x) {
  return typeof x === 'object' && 'current' in x;
}

function isCallbackRef(f) {
  return typeof f === 'function' && typeof f.call === 'function';
}